export const CLEAR_SESSION = 'CLEAR_SESSION'
export const SET_SESSION = 'SET_SESSION'
export const SET_PALETTE_TYPE = 'SET_PALETTE_TYPE'
export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const SET_UPLOAD_STATE = 'SET_UPLOAD_STATE'
export const SET_PASSWORD_EXPIRED = 'SET_PASSWORD_EXPIRED'
export const SET_SHOW_NOTIFICATIONS = 'SET_SHOW_NOTIFICATIONS'
export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT'